
export { default } from './LayoutSidenavFooter';
